import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import packageJson from '../../package.json';
import { NotificationComponent } from './components/notification';
import { initReferrer } from './utils/functions/referrer.utils';

const VERSION_KEY = 'ahc_version';
const CART_KEY = 'ahc_cart';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationComponent],
  template: `<router-outlet />

    @defer {
      <app-notification />
    } `,
})
export class App {
  constructor() {
    this.checkAppVersion();
    initReferrer();
  }

  checkAppVersion() {
    const CURRENT_VERSION = packageJson.version;
    const storedVersion = localStorage.getItem(VERSION_KEY);

    if (!storedVersion || storedVersion !== CURRENT_VERSION) {
      localStorage.removeItem(CART_KEY);
      localStorage.setItem(VERSION_KEY, CURRENT_VERSION);
    }
  }
}
